import {create} from "zustand";

interface AgeTypeState {
  ageValue: number;
  disabledAge: boolean;
  ageString: string;
  setAgeValue: (value: number) => void;
  setDisabledAge: (value: boolean) => void;
  setAgeString: (value: string) => void;
  ageList: string[];
  ageCompValue: number[];
  setAgeCompValue: (value: number[]) => void;
}

const useAgeType = create<AgeTypeState>((set) => ({
  ageValue: 0,
  disabledAge: false,
  ageString: "of all ages",
  setAgeValue: (value) => set((state) => ({ageValue: value})),
  setDisabledAge: (value) => set((state) => ({disabledAge: value})),
  setAgeString: (value) => set((state) => ({ageString: value})),
  ageList: ["All", "<18", "18-34", "35-44", "45-54", "55-64", ">65"],
  ageCompValue: [0, 1],
  setAgeCompValue: (value: number[]) => set(() => ({ageCompValue: value})),
}));
export default useAgeType;
